module.exports = __webpack_public_path__ + "static/media/adelphi-borse.1429b51d.jpg";